import { FC } from 'react';
import Slider from 'react-slick';
import { Asset, Box, Typography } from '@altermaind/web/ui';
import { Badge } from '@/_shared/components';
import { Slide } from '../../../state';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

type Props = {
  slides: Slide[];
};

export const LoginSlider: FC<Props> = ({ slides }) => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipe: false,
  };

  return (
    <Box maxWidth='75vh'>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Slider {...settings}>
        {slides.map(slide => {
          return (
            <Box key={slide.assetName}>
              <Box width='100%' display='flex' alignSelf='center' justifyContent='center'>
                <Asset
                  width='100%'
                  maxHeight={['500px', '500px', '500px', '500px', '500px']}
                  name={slide.assetName}
                  domain='images'
                  mr='-xxxxs'
                />
              </Box>
              <Box maxWidth='500px' justifyContent='flex-start' style={{ margin: '0 auto' }}>
                {slide.hasComing && (
                  <Box mb='xxs'>
                    <Badge
                      label={slide.hasComingLabel ? slide.hasComingLabel : ''}
                      color={'#b080ff' as never}
                      variant='solid'
                    />
                  </Box>
                )}
                <Typography
                  textAlign='center'
                  variant='h1'
                  fontSize={95 as never}
                  lineHeight={'90px' as never}
                  mt='xxxl'
                >
                  {slide.title}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Slider>
    </Box>
  );
};
